import React, { useEffect, useState } from 'react'
import PoacRecords from './poac-records'
import { useIndexedDB } from '../../../context/IndexedContext'
import Alert from './alert-record'
import DifferentialDiagnosisRecords from './differential-record'
import MorseCodeProvider from './morse-records'
import AssessmentRecords from './assessment-records'
import PlanRecords from './plan-records'
import RiskFactorRecords from './riskf-record'
import RiskfactorsFreeTypeRecords from './risk-factors-freetype'

const TreatmentShell = ({ patientDBdata, isSavingTheData,questionValue, setQuestionsValue, patientID, editNoteIndex, loggedUserProvider, MasterDiagnosisData, setPatientDBdata, noteID, noteActualId, }) => {

  const [patientDiagnosis, setPatientDiagnosis] = useState([])

  useEffect(() => {
    const patientD = patientDBdata?.patientData?.Diagnosis?.split(',')
    setPatientDiagnosis(patientD)
  }, [])

  const { getCallCenterQuestions } = useIndexedDB()
  const [freeTypeGlobal, setFreeTypeGlobal] = useState('')

  useEffect(() => {
    const patientD = patientDBdata?.patientData?.Diagnosis?.split(',')
    setPatientDiagnosis(patientD)
  }, [])

  const getLatestDataForPoa = (allPatientHpiData, patientID,) => {

    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      // /  return patientData && patientData[noteID]
      return patientData
    })
    console.log(filtered, 'filtered getLatestNoteByPatientAndNoteID')

    const latest = filtered.at(-1)
    console.log(latest, 'latest getLatestNoteByPatientAndNoteID')
    return latest || null
  }
  
  const getCallCenterDatas = async (diagnosisList) => {


    // let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '');
    // let data = await getCallCenterQuestions();
    // let allData = JSON.parse(data?.d);

    let allData = await getCallCenterQuestions();
    console.log('patinet id allData ', allData);

    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      };
    });

    const result = getLatestDataForPoa(allPatientHpiData, patientID);

    console.log("call center latest data ---> ", result);


    const convertedData = {};

    const callCenterData = result?.[patientID]?.CCENTER;
    const globalFreeType = result?.[patientID]?.globalFreeType
    if (callCenterData) {
      Object.keys(callCenterData).forEach((diagnosis) => {
        convertedData[diagnosis] = callCenterData[diagnosis]?.map((q) => ({
          question: q.label,
          answer: q.answer,
          freeType: q.freeType,
          type: q?.type,
          freewayRemark: q?.freewayRemark
        }));
      });
    }

    setFreeTypeGlobal(globalFreeType)
    setQuestionsValue(convertedData);
    console.log("Converted Call Center Data", convertedData);



    return convertedData;
  };
  useEffect(() => {
    if (Array.isArray(patientDiagnosis) && patientDiagnosis.length > 0) {
      getCallCenterDatas(patientDiagnosis)
    }
  }, [patientDiagnosis])

  return (
    <div className='d-flex align-items-start '>
      <div className='w-100'>
        {
          (patientDiagnosis || [])?.filter(item=>item)?.map((item, idx) => {
            return (
              <>
                <div className='d-flex align-items-start '>
                  <div style={{ minWidth: "23%" }}>{item}</div>
                  <div className='w-100 d-flex flex-column gap-2'>
                   
                    <PoacRecords diagnosis={item} questionValue={questionValue} setQuestionsValue={setQuestionsValue} MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={editNoteIndex} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
                    {/* <RiskFactorRecords diagnosisName={item} questionValue={questionValue} setQuestionsValue={setQuestionsValue} MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={editNoteIndex} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
                    <RiskfactorsFreeTypeRecords diagnosisName={item} questionValue={questionValue} setQuestionsValue={setQuestionsValue} MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={editNoteIndex} noteActualId={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
                 
                    <Alert diagnosisName={item} questionValue={questionValue} setQuestionsValue={setQuestionsValue} MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
                  
                 
                    <DifferentialDiagnosisRecords diagnosisName={item} questionValue={questionValue} setQuestionsValue={setQuestionsValue} MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
                 
                    <MorseCodeProvider diagnosisName={item} questionValue={questionValue} setQuestionsValue={setQuestionsValue} MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
                 
                    <AssessmentRecords diagnosisName={item} questionValue={questionValue} setQuestionsValue={setQuestionsValue} MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
                    <PlanRecords editNoteIndex={editNoteIndex} diagnosisName={item} questionValue={questionValue} setQuestionsValue={setQuestionsValue} MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} noteActualId={noteActualId}/>
                  
                </div>
                  </div>
                <hr />
              </>
            )
          })
        }
      </div>
    </div>
  )
}

export default TreatmentShell